
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[region]/[resort]/schneehoehen-schneebericht",
      function () {
        return require("private-next-pages/[region]/[resort]/schneehoehen-schneebericht.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[region]/[resort]/schneehoehen-schneebericht"])
      });
    }
  